import { ValueLabel } from '../common';

export const properties: ValueLabel<string>[] = [
  { value: 'id', label: 'Request ID' },
  { value: 'deaNumber', label: 'DEA Numbers' },
  { value: 'requestType', label: 'Request Type' },
  { value: 'role', label: 'Role' },
  { value: 'createdAt', label: 'Created Date' },
  { value: 'status', label: 'Status' },

  { value: 'subscriberInfo', label: 'Subscriber Information' },
  { value: 'certificateEmail', label: 'Certificate Email' },

  { value: 'srNum', label: 'Serial Number' },
  { value: 'requestorId', label: 'Requester' },
];

// 10 cols

// indivId: number;
// status: string;
// firstName: string;
// lastName: string;
// middleInitial: string;
// certificateEmail: string;
// deaNumber: string;
// regStatus: string;
// role: string;
// renewalInstNo: string;
// appStatusCd: string;
// regSrc: string;
// srNum: string;
// subscriberAddress: string;
// appStatusDt: Date;
// certExpDt: Date;
// createdAt: Date;
// updatedAt: Date;
